import { createApi } from "./common";

const LOGIN_PATH = "/login";
const LOGOUT_PATH = "/logout";
const PASSWORD_PATH = "/password";
const REFRESH_ACCESS_TOKEN_PATH = "/token";

const authApi = createApi(process.env.REACT_APP_AUTH_API_URL);
export default authApi;

const getPathname = (url) =>
  url.replace(process.env.REACT_APP_AUTH_API_URL, "");

export const changePassword = ({ oldPassword, newPassword }) =>
  authApi.post(PASSWORD_PATH, {
    body: JSON.stringify({ newPassword, oldPassword }),
    credentials: "include",
  });

export const isInvalidOldPasswordError = (err) => err.status === 409;

export const isLoginRequest = (request) =>
  getPathname(request.url) === LOGIN_PATH && request.method === "POST";

export const isRefreshTokenRequest = (request) =>
  getPathname(request.url) === REFRESH_ACCESS_TOKEN_PATH &&
  request.method === "POST";

export const isUnauthorizedResponse = (response) =>
  !response.ok && response.status === 401;

export const login = ({ email, password }) =>
  authApi
    .post(LOGIN_PATH, {
      body: JSON.stringify({ email, password }),
      credentials: "include",
    })
    .catch((err) => {
      if (err.status === 401) {
        throw new Error("Invalid login credentials");
      }
      if (err.status === 400) {
        throw new Error("Please provide a correct email and password");
      }
      throw new Error(
        "Oops, sorry we can't log you in at the moment. Please try again later.",
      );
    });

export const logout = () =>
  authApi.post(LOGOUT_PATH, {
    credentials: "include",
  });

let refreshAllTokensPromise;

export const refreshAllTokens = () => {
  if (!refreshAllTokensPromise) {
    refreshAllTokensPromise = authApi
      .post(REFRESH_ACCESS_TOKEN_PATH, {
        credentials: "include",
      })
      .finally(() => {
        refreshAllTokensPromise = null;
      });
  }
  return refreshAllTokensPromise;
};
